import React, { FC } from "react";

const VideoTutorial: FC = () => {
	const videoFiles = [
		{ description: "API Token", fileName: "Api_Token.mp4" },
		{
			description: "Detaje per fushen e financave",
			fileName: "Detaje_per_fushen_e_Financave.mp4",
		},
		{
			description: "Kerkimi i barazimeve dhe refuzimeve",
			fileName: "Kerkimi_i_barazimeve_dhe_refuzimeve.mp4",
		},
		{ description: "Ndarja e zonave", fileName: "Ndarja_e_zonave.mp4" },
		{ description: "Nenklienti", fileName: "Nenklienti.mp4" },
		{
			description: "Porosite per grumbullim",
			fileName: "Porosite_per_grumbullim.mp4",
		},
		{ description: "Rinisja", fileName: "Rinisja.mp4" },
		{
			description: "Shablloni i porosive",
			fileName: "Shablloni_i_porosivet.mp4",
		},
		{ description: "Sign up", fileName: "Signup.mp4" },
		{
			description: "Kodi unik i klientit",
			fileName: "Spjegime_per_Kodin_Unik_te_klientit.mp4",
		},
		{
			description: "Dimensionet e pakos",
			fileName: "Dimensionet_e_pakos.mp4",
		},
		{
			description: "Linku i perkohshem per bleresit",
			fileName: "Temporary_link.mp4",
		},
	];

	return (
		<div
			style={{
				display: "flex",
				flexWrap: "wrap",
				justifyContent: "space-between",
				marginLeft: "10px",
			}}
		>
			{videoFiles.map((e, i) => {
				return (
					<div
						key={i}
						style={{ flex: "0 1 48%", marginBottom: "20px" }}
					>
						<h1 style={{ fontWeight: "bolder" }}>
							{e.description}
						</h1>
						<video width="100%" controls>
							<source
								src={"videos/" + e.fileName}
								type="video/mp4"
							/>
							Your browser does not support the video tag.
						</video>
					</div>
				);
			})}
		</div>
	);
};

export default VideoTutorial;
